import { useState, useEffect, useMemo, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import CustomForm from "components/Common/Form";
import { EMPLOYEE_FORM_CONFIG } from "./config";
import { useAlert } from "context/alert";
import zoneLocalStorageId from "utils/zone";
import Loader from "components/Common/loader";
import {
  createPatientCoordinatorAgent,
  updatePatientCoordinatorAgent,
} from "services/patientCoordinatorAgents";
import { useSelector } from "react-redux";

const AddEmployee = ({ onClose, rowData, handleOpenChangePassModal }) => {
  const {
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => {
      return rowData;
    }, [rowData]),
  });
  const { showAlert } = useAlert();

  const [createdDoctorData, setCreatedDoctorData] = useState(null);

  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);

  const onSuccess = (response) => {
    const refetchEmployees = true;
    const message = rowData
      ? "Agent updated successfully!"
      : "Agent created successfully!";
    showAlert(message, "success");

    if (response?.data) {
      setCreatedDoctorData(response.data);
    }

    onClose(refetchEmployees, response?.data);
  };

  // const onError = (err) => {
  //   const errorDetail = err?.response?.data?.detail;
  //   const message = typeof errorDetail === "string" ? errorDetail : errorDetail[0]?.msg || JSON.stringify(errorDetail[0]?.msg);
  //   showAlert(message, "danger");
  // };

  const onError = useCallback((error) => {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong!";
    const errorDetail = error?.response?.data?.detail;
    showAlert(errorMessage, "danger", errorDetail);
  }, []);

  const { mutate: addEmployeesMutate, isLoading: isLoadingAdd } = useMutation({
    mutationFn: createPatientCoordinatorAgent,
    onSuccess,
    onError,
  });

  const { mutate: updateEmployeesMutate, isLoading: isLoadingUpdate } =
    useMutation({
      mutationFn: updatePatientCoordinatorAgent,
      onSuccess,
      onError,
    });

  const isSubmitting = isLoadingAdd || isLoadingUpdate;

  const SubmitEmployees = async (values, e) => {
    e.preventDefault();

    const today = new Date().toISOString().split("T")[0];

    const fullPayload = {
      agent_name: values.agent_name,
      mobile: values.mobile,
      email: values.email,
      address: values.address,
      joining_date: today,
      is_working: values.is_working,
      with_effect_from: today,
      // most_recent: values.most_recent,
      password: values.password,
      is_active: true,
      zone_id: values.zone_id || zoneLocalStorageId(),
      father_name: values.father_name,
      mother_name: values.mother_name,
      dob: values.dob,
      esi_no: values.esi_no,
      pan_no: values.pan_no,
      qualification: values.qualification,
      epf_no: values.epf_no,
      passport_no: values.passport_no,
      blood_group: values.blood_group,
      username: values.username,
      marketing_person: values.marketing_person_id,
      created_by: jwtAuthreducer?.user?.employee_code_id,
    };

    if (rowData?.id) {
      fullPayload.id = rowData.id;
      updateEmployeesMutate(fullPayload);
    } else {
      addEmployeesMutate(fullPayload);
    }

    reset();
  };

  useEffect(() => {
    reset(rowData);
  }, [rowData, reset]);

  return (
    <div style={{ position: "relative" }}>
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Loader isLoading={true} />
        </div>
      )}

      <CustomForm
        config={EMPLOYEE_FORM_CONFIG(rowData)}
        onSubmit={SubmitEmployees}
        columnCount={3}
        rowData={rowData}
        isAdditional={8}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default AddEmployee;
